<template>
    <div v-if="orders">
        <b-table
            :data="orders.data"
            :default-sort="[config.sort, config.sortDirection]"
            :loading="loading"
            class="table-striped my-table"

            :narrowed="true"

            :mobile-cards="true"
            :per-page="config.per_page"
            :show-detail-icon="true"

            :striped="true"
            :total="orders.total"

            backend-filtering
            backend-pagination
            backend-sorting

            paginated
            @sort="onSort"
            @page-change="onPageChange"
            @filters-change="onFilterChange"
        >
            <b-table-column label="N°" field="id" sortable searchable width="0">
                <div slot="default" slot-scope="props">
                    {{ props.row.id }}
                </div>
            </b-table-column>

            <b-table-column label="Code Client" field="client_id" sortable searchable width="0">
                <div slot="default" slot-scope="props">
                    {{ props.row.client_id }}
                </div>
            </b-table-column>

            <b-table-column label="Client" field="client_name_or_enseigne">
                <div slot="default" slot-scope="props">
                    <span v-if="props.row.client.enseigne">{{ props.row.client.enseigne }}</span>
                    <span v-else>{{ props.row.client.nom }}</span>
                </div>
            </b-table-column>

            <b-table-column label="Date de commande" field="date_commande" sortable>
                <div slot="default" slot-scope="props">
                    {{ moment(props.row.date_commande).format('L') }}
                </div>
            </b-table-column>

            <b-table-column label="Date de livraison" field="date_livraison" sortable>
                <div slot="default" slot-scope="props">
                    <span v-if="props.row.date_livraison">{{ moment(props.row.date_livraison).format('L') }}</span>
                </div>
            </b-table-column>

            <b-table-column label="Statut" field="statut" sortable searchable>
                <div slot="default" slot-scope="props">
                    <span v-if="props.row.statut === 'traitée'">Traitée</span>
                    <span v-if="props.row.statut === 'attente_envoi'">En attente d'envoi</span>
                </div>
                <div slot="searchable" slot-scope="props">
                    <div class="w-100">
                        <select v-model="props.filters[props.column.field]" class="form-control mb-3">
                            <option value="">&nbsp;</option>
                            <option value="traitée">Traitée</option>
                            <option value="attente_envoi">En attente d'envoi</option>
                        </select>
                    </div>
                </div>
            </b-table-column>

            <b-table-column label="Commercial" field="nom_commercial">
                <div slot="default" slot-scope="props">
                    {{ props.row.client.commercial.nom_prenom }}
                </div>
            </b-table-column>

            <b-table-column label="Actions">
                <div slot="default" slot-scope="props">
                    <a :href="`/administration/commandes/commande/${props.row.id}`">Voir le détail</a>
                </div>
            </b-table-column>
        </b-table>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
    name: 'OrdersTable',
    components: {},
    props: [],
    data: function () {
        return {
            loading: false,
        }
    },
    created() {
        this.loadAsyncData();
    },
    computed: {
        ...mapState('order', {
            orders: state => state.orders,
            config: state => state.ordersConfig,
        }),
        dateFrom: {
            get() {
                return this.$store.state.order.date_from
            },
            set(value) {
                this.$store.commit('order/setDateFrom', value)
            }
        },
        dateTo: {
            get() {
                return this.$store.state.order.date_to
            },
            set(value) {
                this.$store.commit('order/setDateTo', value)
            }
        },
    },
    methods: {
        ...mapActions('order', [
            'getOrders',
        ]),

        loadAsyncData() {
            this.loading = true;
            this.getOrders().finally(() => {
                this.loading = false;
            })
        },
        onSort(field, order) {
            this.config.sort = field
            this.config.sortDirection = order

            this.loadAsyncData()
        },
        onFilterChange(filter) {
            var filters = {};
            Object.keys(filter).forEach((element) => {
                filters[element] = filter[element]
            })
            this.config.filters = filters

            this.loadAsyncData()
        },
        onPageChange(page) {
            this.config.page = page

            this.loadAsyncData()
        },

    },
    mounted() {

    }
}
</script>
